// Badge definitions with various types and categories
export const BADGE_TYPES = {
  STREAK: 'streak',
  LEVEL: 'level',
  LESSON: 'lesson',
  QUIZ: 'quiz',
  XP: 'xp',
  FACT: 'fact',
  PERFECT: 'perfect',
  MASTERY: 'mastery',
  MILESTONE: 'milestone'
};

export const BADGE_RARITY = {
  COMMON: 'common',
  UNCOMMON: 'uncommon',
  RARE: 'rare',
  EPIC: 'epic',
  LEGENDARY: 'legendary'
};

// Badge definitions
export const BADGE_DEFINITIONS = {
  // Streak Badges
  'streak-3': {
    id: 'streak-3',
    name: 'Getting Started',
    description: 'Complete daily facts for 3 consecutive days',
    type: BADGE_TYPES.STREAK,
    rarity: BADGE_RARITY.COMMON,
    icon: '🔥',
    color: '#f97316', // orange
    bgColor: '#fff7ed',
    requirement: { type: 'streak', value: 3 }
  },
  'streak-7': {
    id: 'streak-7',
    name: 'Fact Finder',
    description: 'Complete daily facts for 7 consecutive days',
    type: BADGE_TYPES.STREAK,
    rarity: BADGE_RARITY.UNCOMMON,
    icon: '🔥',
    color: '#ea580c',
    bgColor: '#fff7ed',
    requirement: { type: 'streak', value: 7 }
  },
  'streak-14': {
    id: 'streak-14',
    name: 'Dedicated Learner',
    description: 'Complete daily facts for 14 consecutive days',
    type: BADGE_TYPES.STREAK,
    rarity: BADGE_RARITY.RARE,
    icon: '🔥',
    color: '#c2410c',
    bgColor: '#fff7ed',
    requirement: { type: 'streak', value: 14 }
  },
  'streak-30': {
    id: 'streak-30',
    name: 'Streak Master',
    description: 'Complete daily facts for 30 consecutive days',
    type: BADGE_TYPES.STREAK,
    rarity: BADGE_RARITY.EPIC,
    icon: '🔥',
    color: '#9a3412',
    bgColor: '#fff7ed',
    requirement: { type: 'streak', value: 30 }
  },
  'streak-60': {
    id: 'streak-60',
    name: 'Fire Keeper',
    description: 'Complete daily facts for 60 consecutive days',
    type: BADGE_TYPES.STREAK,
    rarity: BADGE_RARITY.LEGENDARY,
    icon: '🔥',
    color: '#7c2d12',
    bgColor: '#fff7ed',
    requirement: { type: 'streak', value: 60 }
  },
  'streak-100': {
    id: 'streak-100',
    name: 'Unstoppable',
    description: 'Complete daily facts for 100 consecutive days',
    type: BADGE_TYPES.STREAK,
    rarity: BADGE_RARITY.LEGENDARY,
    icon: '🔥',
    color: '#431407',
    bgColor: '#fff7ed',
    requirement: { type: 'streak', value: 100 }
  },

  // Level Badges
  'level-5': {
    id: 'level-5',
    name: 'Rising Star',
    description: 'Reach level 5',
    type: BADGE_TYPES.LEVEL,
    rarity: BADGE_RARITY.COMMON,
    icon: '⭐',
    color: '#fbbf24',
    bgColor: '#fffbeb',
    requirement: { type: 'level', value: 5 }
  },
  'level-10': {
    id: 'level-10',
    name: 'Bright Mind',
    description: 'Reach level 10',
    type: BADGE_TYPES.LEVEL,
    rarity: BADGE_RARITY.UNCOMMON,
    icon: '⭐',
    color: '#f59e0b',
    bgColor: '#fffbeb',
    requirement: { type: 'level', value: 10 }
  },
  'level-20': {
    id: 'level-20',
    name: 'Scholar',
    description: 'Reach level 20',
    type: BADGE_TYPES.LEVEL,
    rarity: BADGE_RARITY.RARE,
    icon: '⭐',
    color: '#d97706',
    bgColor: '#fffbeb',
    requirement: { type: 'level', value: 20 }
  },
  'level-30': {
    id: 'level-30',
    name: 'Expert',
    description: 'Reach level 30',
    type: BADGE_TYPES.LEVEL,
    rarity: BADGE_RARITY.EPIC,
    icon: '⭐',
    color: '#b45309',
    bgColor: '#fffbeb',
    requirement: { type: 'level', value: 30 }
  },
  'level-50': {
    id: 'level-50',
    name: 'Master',
    description: 'Reach level 50',
    type: BADGE_TYPES.LEVEL,
    rarity: BADGE_RARITY.LEGENDARY,
    icon: '⭐',
    color: '#92400e',
    bgColor: '#fffbeb',
    requirement: { type: 'level', value: 50 }
  },

  // Lesson Badges
  'lesson-1': {
    id: 'lesson-1',
    name: 'First Steps',
    description: 'Complete your first lesson',
    type: BADGE_TYPES.LESSON,
    rarity: BADGE_RARITY.COMMON,
    icon: '📚',
    color: '#3b82f6',
    bgColor: '#eff6ff',
    requirement: { type: 'lessons', value: 1 }
  },
  'lesson-5': {
    id: 'lesson-5',
    name: 'Knowledge Seeker',
    description: 'Complete 5 lessons',
    type: BADGE_TYPES.LESSON,
    rarity: BADGE_RARITY.UNCOMMON,
    icon: '📚',
    color: '#2563eb',
    bgColor: '#eff6ff',
    requirement: { type: 'lessons', value: 5 }
  },
  'lesson-10': {
    id: 'lesson-10',
    name: 'Dedicated Student',
    description: 'Complete 10 lessons',
    type: BADGE_TYPES.LESSON,
    rarity: BADGE_RARITY.RARE,
    icon: '📚',
    color: '#1d4ed8',
    bgColor: '#eff6ff',
    requirement: { type: 'lessons', value: 10 }
  },
  'lesson-25': {
    id: 'lesson-25',
    name: 'Course Conqueror',
    description: 'Complete 25 lessons',
    type: BADGE_TYPES.LESSON,
    rarity: BADGE_RARITY.EPIC,
    icon: '📚',
    color: '#1e40af',
    bgColor: '#eff6ff',
    requirement: { type: 'lessons', value: 25 }
  },
  'lesson-50': {
    id: 'lesson-50',
    name: 'Learning Legend',
    description: 'Complete 50 lessons',
    type: BADGE_TYPES.LESSON,
    rarity: BADGE_RARITY.LEGENDARY,
    icon: '📚',
    color: '#1e3a8a',
    bgColor: '#eff6ff',
    requirement: { type: 'lessons', value: 50 }
  },

  // Quiz Badges
  'quiz-1': {
    id: 'quiz-1',
    name: 'Quiz Taker',
    description: 'Complete your first quiz',
    type: BADGE_TYPES.QUIZ,
    rarity: BADGE_RARITY.COMMON,
    icon: '📝',
    color: '#8b5cf6',
    bgColor: '#f5f3ff',
    requirement: { type: 'quizzes', value: 1 }
  },
  'quiz-5': {
    id: 'quiz-5',
    name: 'Quiz Enthusiast',
    description: 'Complete 5 quizzes',
    type: BADGE_TYPES.QUIZ,
    rarity: BADGE_RARITY.UNCOMMON,
    icon: '📝',
    color: '#7c3aed',
    bgColor: '#f5f3ff',
    requirement: { type: 'quizzes', value: 5 }
  },
  'quiz-10': {
    id: 'quiz-10',
    name: 'Test Master',
    description: 'Complete 10 quizzes',
    type: BADGE_TYPES.QUIZ,
    rarity: BADGE_RARITY.RARE,
    icon: '📝',
    color: '#6d28d9',
    bgColor: '#f5f3ff',
    requirement: { type: 'quizzes', value: 10 }
  },
  'quiz-perfect': {
    id: 'quiz-perfect',
    name: 'Perfect Score',
    description: 'Get a perfect score on a quiz',
    type: BADGE_TYPES.PERFECT,
    rarity: BADGE_RARITY.RARE,
    icon: '💯',
    color: '#ec4899',
    bgColor: '#fdf2f8',
    requirement: { type: 'perfect_quiz', value: 1 }
  },
  'quiz-mastery': {
    id: 'quiz-mastery',
    name: 'Quiz Master',
    description: 'Score above 95% on a quiz',
    type: BADGE_TYPES.MASTERY,
    rarity: BADGE_RARITY.EPIC,
    icon: '🎯',
    color: '#db2777',
    bgColor: '#fdf2f8',
    requirement: { type: 'mastery_quiz', value: 1 }
  },

  // XP Badges
  'xp-1000': {
    id: 'xp-1000',
    name: 'XP Collector',
    description: 'Earn 1,000 XP',
    type: BADGE_TYPES.XP,
    rarity: BADGE_RARITY.COMMON,
    icon: '💰',
    color: '#10b981',
    bgColor: '#ecfdf5',
    requirement: { type: 'xp', value: 1000 }
  },
  'xp-5000': {
    id: 'xp-5000',
    name: 'XP Accumulator',
    description: 'Earn 5,000 XP',
    type: BADGE_TYPES.XP,
    rarity: BADGE_RARITY.UNCOMMON,
    icon: '💰',
    color: '#059669',
    bgColor: '#ecfdf5',
    requirement: { type: 'xp', value: 5000 }
  },
  'xp-10000': {
    id: 'xp-10000',
    name: 'XP Millionaire',
    description: 'Earn 10,000 XP',
    type: BADGE_TYPES.XP,
    rarity: BADGE_RARITY.RARE,
    icon: '💰',
    color: '#047857',
    bgColor: '#ecfdf5',
    requirement: { type: 'xp', value: 10000 }
  },
  'xp-25000': {
    id: 'xp-25000',
    name: 'XP Tycoon',
    description: 'Earn 25,000 XP',
    type: BADGE_TYPES.XP,
    rarity: BADGE_RARITY.EPIC,
    icon: '💰',
    color: '#065f46',
    bgColor: '#ecfdf5',
    requirement: { type: 'xp', value: 25000 }
  },
  'xp-50000': {
    id: 'xp-50000',
    name: 'XP Legend',
    description: 'Earn 50,000 XP',
    type: BADGE_TYPES.XP,
    rarity: BADGE_RARITY.LEGENDARY,
    icon: '💰',
    color: '#064e3b',
    bgColor: '#ecfdf5',
    requirement: { type: 'xp', value: 50000 }
  },

  // Fact Badges
  'fact-10': {
    id: 'fact-10',
    name: 'Fact Collector',
    description: 'Complete 10 daily facts',
    type: BADGE_TYPES.FACT,
    rarity: BADGE_RARITY.COMMON,
    icon: '💡',
    color: '#06b6d4',
    bgColor: '#ecfeff',
    requirement: { type: 'facts', value: 10 }
  },
  'fact-25': {
    id: 'fact-25',
    name: 'Fact Enthusiast',
    description: 'Complete 25 daily facts',
    type: BADGE_TYPES.FACT,
    rarity: BADGE_RARITY.UNCOMMON,
    icon: '💡',
    color: '#0891b2',
    bgColor: '#ecfeff',
    requirement: { type: 'facts', value: 25 }
  },
  'fact-50': {
    id: 'fact-50',
    name: 'Fact Master',
    description: 'Complete 50 daily facts',
    type: BADGE_TYPES.FACT,
    rarity: BADGE_RARITY.RARE,
    icon: '💡',
    color: '#0e7490',
    bgColor: '#ecfeff',
    requirement: { type: 'facts', value: 50 }
  },
  'fact-100': {
    id: 'fact-100',
    name: 'Fact Legend',
    description: 'Complete 100 daily facts',
    type: BADGE_TYPES.FACT,
    rarity: BADGE_RARITY.LEGENDARY,
    icon: '💡',
    color: '#155e75',
    bgColor: '#ecfeff',
    requirement: { type: 'facts', value: 100 }
  }
};

// Get badge by ID
export const getBadgeById = (badgeId) => {
  return BADGE_DEFINITIONS[badgeId] || null;
};

// Get all badges
export const getAllBadges = () => {
  return Object.values(BADGE_DEFINITIONS);
};

// Get badges by type
export const getBadgesByType = (type) => {
  return Object.values(BADGE_DEFINITIONS).filter(badge => badge.type === type);
};

// Get badges by rarity
export const getBadgesByRarity = (rarity) => {
  return Object.values(BADGE_DEFINITIONS).filter(badge => badge.rarity === rarity);
};

// Check if user has earned a badge
export const hasBadge = (userBadges, badgeId) => {
  if (!userBadges || !Array.isArray(userBadges)) return false;
  return userBadges.some(badge => badge.id === badgeId);
};

// Get rarity color
export const getRarityColor = (rarity) => {
  const colors = {
    [BADGE_RARITY.COMMON]: '#8b8f9c',
    [BADGE_RARITY.UNCOMMON]: '#ff7a9c',
    [BADGE_RARITY.RARE]: '#ff4d6d',
    [BADGE_RARITY.EPIC]: '#ff8a5b',
    [BADGE_RARITY.LEGENDARY]: '#f59e0b'
  };
  return colors[rarity] || colors[BADGE_RARITY.COMMON];
};


